// extracted by mini-css-extract-plugin
module.exports = {"lia-description":"SwitchBranchFloatingBox_lia-description__t3K55"};